import { BlogArticle, BlogInlineImage, BlogTakeaways } from "../BlogArticle";
import { getBlogSummary } from "../blogIndex";

const post = getBlogSummary("2")!;

export default function HowIHelpedMySisterFindMalwareInRobloxStudio() {
  return (
    <BlogArticle post={post}>
      <p>
        Recently, my 7-year-old sister started using Roblox Studio. She is still
        learning and does not know how to make her own models yet, but she likes
        importing models from the Toolbox.
      </p>

      <p>
        One day, she inserted a Hello Kitty rug model into her game. As soon as
        she did that, a strange pop-up appeared saying there was an "ERROR 501".
        It told us to copy and paste a script into the game to fix it.
      </p>

      <BlogInlineImage
        src="/assets/images/blog/roblox-studio-hello-kitty-rug.jpg"
        alt="The Hello Kitty rug model inside a Roblox Studio scene"
        caption="The Hello Kitty rug model looked harmless at first, which is why the pop-up felt so confusing."
      />

      <BlogInlineImage
        src="/assets/images/blog/roblox-studio-error-501-popup.jpg"
        alt="A suspicious Error 501 pop-up in Roblox Studio asking users to paste a script"
        caption="This was the suspicious pop-up. The big warning sign was that it asked us to copy and paste code."
      />

      <p>
        Something felt suspicious. When I looked at the script, I noticed words
        like "destroy" and "install" inside it. That did not seem like
        something a normal Roblox error would ask us to do.
      </p>

      <p>
        At first, I thought it might be a real Roblox error, so I pasted the
        code into the game to test it. Nothing happened. My sister could not
        remember exactly which model she had inserted, so I was not sure what
        caused the problem.
      </p>

      <p>
        Then I remembered that Roblox usually has specific error codes, and I
        did not think Error 501 was a real Roblox Studio error. So I started
        checking the models one by one.
      </p>

      <p>
        Eventually, I found a Hello Kitty rug model that contained a huge amount
        of code. That seemed very suspicious, so I deleted it. After removing
        it, everything went back to normal.
      </p>

      <BlogInlineImage
        src="/assets/images/blog/roblox-studio-suspicious-model-tree.jpg"
        alt="Roblox Studio Explorer showing suspicious scripts hidden inside the Hello Kitty rug model"
        caption="The Explorer view showed hidden scripts and extra objects inside the model, which made it look unsafe."
        fit="contain"
        maxWidth="max-w-xl"
      />

      <p>
        To make sure I understood what happened, I copied the script and pasted
        it into Claude to analyse it. The analysis showed that the script could
        install backdoors and other malicious scripts into the game. These could
        potentially affect players who joined the game.
      </p>

      <p>
        Because we could not be completely sure that the game was safe anymore,
        we decided to delete the game and start over.
      </p>

      <h2>What Other Roblox Creators Should Watch Out For</h2>

      <p>
        If you are a Roblox player or an aspiring Roblox game creator, always be
        careful when using free models from the Toolbox. Before inserting a
        model into your game, check who created it, read the comments if
        available, and inspect any scripts it contains.
      </p>

      <p>
        Never paste code into your game just because a pop-up tells you to. Real
        Roblox errors do not require you to copy and run random scripts. If
        something looks suspicious, take time to investigate it before
        continuing.
      </p>

      <p>
        Most importantly, keep backups of your projects and do not be afraid to
        remove a model if it seems unsafe. A little caution can help protect
        your game, your work, and the players who join your creations.
      </p>

      <BlogTakeaways
        items={[
          "Free Toolbox models can contain hidden scripts, so they should be inspected before use.",
          "A random pop-up asking you to paste code is a serious warning sign.",
          "Real Roblox Studio errors do not need you to run mystery scripts to fix them.",
          "If a game may have been infected, starting over can be safer than guessing.",
          "Backups are important because they give you a clean version to return to.",
        ]}
      />
    </BlogArticle>
  );
}
